module.exports = __webpack_public_path__ + "img/Foto_ForstwartEFZ_9O1A4476_2019.75451a7d.jpg";